import * as React from 'react';
import { Config, isCompleted } from '../../helper';
import VideoPlayer from '../VideoPlayer';
import { Button, SkipButton } from '../Buttons';
import Footer from '../Footer';
import { useZustand } from 'use-zustand';
import { pathwayStore } from '../../store';

export default function Video(props) {
  const {step} = props;
  const {
    config,
    optional = false,
  } = step;
  const {cta} = config;
  const {
    updateStep,
    pathwayID,
    completedStepIDs,
    skippedStepIDs,
  } = useZustand(pathwayStore, (state) => ({
    pathwayID: state.pathwayID,
    updateStep: state.updateStep,
    completedStepIDs: state.completedStepIDs,
    skippedStepIDs: state.skippedStepIDs,
  }));
  const completed = isCompleted(step.id, completedStepIDs());
  const skipped = isCompleted(step.id, skippedStepIDs());
  const [canCompleteStep, setCanCompleteStep] = React.useState(false);
  const [isNextStepDisabled, setIsNextStepDisabled] = React.useState(true);
  const [buttonClicked, setButtonClicked] = React.useState(false);

  React.useEffect(() => {
    const check = () => {
      if (completed) {
        return true;
      }

      if (skipped) {
        return false;
      }

      return canCompleteStep === false;
    }
    setIsNextStepDisabled(check());
  },[completed, skipped, canCompleteStep])

  const skipStep = (evt) => {
    evt.preventDefault();
    setButtonClicked(true);
    updateStep(pathwayID, step, Config.Step.Status.skipped);
  }

  const completeStep = (evt) => {
    evt.preventDefault();
    evt.target.disabled = true;
    setButtonClicked(true);
    updateStep(pathwayID, step, Config.Step.Status.completed);
  }

  return (
    <div className='pathway-step__details'>
      <div className='pathway-step__content'>
        <VideoPlayer config={config} completeSetter={setCanCompleteStep} buttonClicked={buttonClicked}/>
        <div className='pathway-step__main' dangerouslySetInnerHTML={{__html: step.content}}></div>
      </div>
      <div className='pathway-step__actions'>
        {optional && !skipped && !completed && <SkipButton text={'Skip'} completed={completed} clickHandler={skipStep}/>}
        <Button text={cta} disabled={isNextStepDisabled } clickHandler={completeStep}/>
      </div>
      <Footer content={step.footer}/>
    </div>
  );
}
